import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { injectContentsquareScript } from '@contentsquare/tag-sdk'
import Vue3Toastify, { type ToastContainerOptions } from 'vue3-toastify'
import { i18n } from './config/i18n'
import { initializeAnalytics } from './config/analytics'
import { useAuthStore } from './stores/auth'
import 'vue3-toastify/dist/index.css'
import './style.css'
import './assets/css/fonts.css'
import './assets/css/rich-text.css'
import './assets/css/datepicker-dark.css'
import App from './App.vue'
import router from './router'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import './assets/css/vue-tel-input.css';
import { vOverflowTooltip } from './directives/vOverflowTooltip';


if (!window.location.hostname.includes('localhost')) {
  injectContentsquareScript({
    siteId: "5276981",
    async: true,
    defer: false
  })
}


const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)
app.component('VueDatePicker', VueDatePicker);
app.directive('overflow-tooltip', vOverflowTooltip);
app.use(VueTelInput);
app.use(Vue3Toastify, {
  autoClose: 3000,
  position: 'top-right',
  theme: 'colored',
} as ToastContainerOptions)

const authStore = useAuthStore()
initializeAnalytics(app, router, authStore.user?.uid)

app.mount('#app')